import { globalStyle, style } from '@vanilla-extract/css';

export const modalDialogContent = style({
  backgroundColor: 'var(--site-theme-background-color, #ffffff)',
  borderColor: 'var(--site-theme-border-color, #e5e7eb)',
  borderRadius: 'var(--site-theme-border-radius, 6px)',
  borderStyle: 'solid',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'stretch',
  borderWidth: '1px',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      height: '100%',
      maxHeight: '90dvh',
      borderRadius: 'var(--site-theme-border-radius, 6px) var(--site-theme-border-radius, 6px) 0 0',
      borderBottomWidth: 0,
    },
    'only screen and (--desktop)': {
      maxHeight: '90dvh',
      overflowY: 'hidden', // Let the inner content handle scrolling
    },
  },
});

export const modalContentContainer = style({
  display: 'flex',
  margin: '0 auto',
  position: 'relative',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  height: '100%',
  '@media': {
    'only screen and (--mobile)': {
      width: '100%',
      maxWidth: '100%',
      position: 'initial',
    },
  },
});

globalStyle(`${modalContentContainer}::-webkit-scrollbar`, {
  display: 'none',
});

globalStyle(`${modalDialogContent}::-webkit-scrollbar`, {
  display: 'none',
});
